module.exports = __webpack_public_path__ + "img/10-img.dd43711e.jpg";